import { Tabs, TabsProps } from "antd";
import QueryString from "qs";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useSpecial from "../../../hooks/useSpecial";
import { theme } from "../../../theme";

interface TabPageLayoutProps {
  tabMenu: TabsProps["items"];
}

export const TabPageLayout: React.FC<TabPageLayoutProps> = ({
  tabMenu = [],
}) => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { special } = useSpecial();

  const [activeKey, setActiveKey] = useState(tabMenu[0].key);

  const specialCode = useMemo(() => {
    if (special) {
      const stringfy = special.replace("?", "");
      const parseCode = QueryString.parse(stringfy);

      return parseCode;
    }

    return undefined;
  }, [special]);

  useEffect(() => {
    const tab = searchParams.get("tab");

    if (tab && tabMenu.find(({ key }) => tab === key)) {
      setActiveKey(tab);
    } else {
      setSearchParams({
        tab: tabMenu[0].key as string,
        ...(specialCode && { ...specialCode }),
      });
    }
  }, [pathname, searchParams, specialCode]);

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) =>
        setSearchParams({ tab: key, ...(specialCode && { ...specialCode }) })
      }
      tabBarStyle={{
        position: "fixed",
        left: 210,
        top: 57,
        right: 0,
        background: "#fff",
        padding: "0 20px",
        borderBottom: `1px solid ${theme.colors.gray7}`,
        zIndex: 5,
      }}
      destroyInactiveTabPane
      items={tabMenu}
    />
  );
};
